import React from 'react';

import LockUrl from '@pkg/assets/images/Lock.png';
import { DepButton, DepInputSize, DepPassword } from '@pkg/components/deprecated';

import { Typography } from '../../DesignSystem';
import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from '../Web3Auth.style';

export function ResetPassword() {
    return (
        <Container>
            <Section className="hide-on-tablet">
                <EmojiImage src={LockUrl} />
            </Section>

            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Reset your password{' '}
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    Pick something strong that you&apos;ll remember!
                </Typography>
            </PrimaryCopySection>

            <Section>
                <FormGroup>
                    <FormRow>
                        <DepPassword label="Password" sizeVariant={DepInputSize.Compact} />
                    </FormRow>
                    <FormRow>
                        <DepPassword label="Retype Password" sizeVariant={DepInputSize.Compact} />
                    </FormRow>
                    <FormRow>
                        <DepButton variant="glow" disabled>
                            Reset Password
                        </DepButton>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
